var map = {
	"./01_listenKey.json": "jg15",
	"./02_balance.json": "W9nQ",
	"./03_order.json": "/xkA",
	"./04_setting.json": "pHnt"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xE4z";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/swapV2/websocket/account \.json$
// module id = xE4z
// module chunks = 3